import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { MapStyle } from "@/shared/types";
import { MapStyles } from "../MapStyles/getMapStyles";

interface MapStyleControllerProps {
  mapStyle: MapStyle;
  showLabels: boolean;
}

function MapStyleController({ mapStyle, showLabels }: MapStyleControllerProps) {
  const map = useMap();
  const showLabelsValue = showLabels ? "on" : "off";
  useEffect(() => {
    if (!map) return;

    map.setOptions({ styles: MapStyles(showLabelsValue)[mapStyle] });
  }, [map, mapStyle, showLabelsValue]);

  return null;
}

export { MapStyleController };
